<template>
    <main class="app-content">
        <div class="app-title">
            <div>
                <h1>
                    <font-awesome-icon icon="globe" />
                    {{$t('title')}}
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="tile">
                    <div class="form-inline">
                        <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                            :placeholder="$t('keyword')"></b-form-input>
                        <button @click="load" class="btn btn-primary mr-1 mb-1">{{$t('search')}}</button>
                        <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
                    </div>
                </div>
            </div>
            <!-- c-paging -->
            <div class="col-12">
                <div class="c-sorting">
                    <div class="row">
                        <div class="col-lg-12 c-sorting__right">
                            <div class="c-sorting__btn">
                                <button @click="create" class="btn btn-sm btn-success">
                                    <font-awesome-icon icon="plus" />&nbsp;{{$t('create')}}
                                </button>
                            </div>
                        </div>
                        <!-- col -->
                    </div>
                    <!-- row -->
                </div>
                <!-- c-sorting -->
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount">
                        {{$t('found', [itemCount])}}
                    </div>
                    <div class="c-paging__right">
                        <div class="c-paging__numbers">
                            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                                v-model="filterFormModel.page" :total-rows="itemCount"
                                :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- c-paging -->
            <div class="col-12" v-if="items.length">
                <div class="c-smart-table tile">
                    <div class="row c-smart-table__title">
                        <div class="col-lg-2">{{$t('name')}}</div>
                        <div class="col-lg-2">{{$t('localeCode')}}</div>
                        <div class="col-lg-2">{{$t('languageCode')}}</div>
                        <div class="col-lg-2">{{$t('phonePrefix')}}</div>
                        <div class="col-lg-2">{{$t('currency')}}</div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row" v-for="item in items" :key="item._id">
                        <div class="col-lg-2">
                            <b class="c-smart-table__label">{{$t('name')}}: </b>
                            <span>{{item.name}}</span>
                        </div>
                        <div class="col-lg-2">
                            <b class="c-smart-table__label">{{$t('localeCode')}}: </b>
                            <span>{{item.localeCode}}</span>
                        </div>
                        <div class="col-lg-2">
                            <b class="c-smart-table__label">{{$t('languageCode')}}: </b>
                            <span>{{item.languageCode}}</span>
                        </div>
                        <div class="col-lg-2">
                            <b class="c-smart-table__label">{{$t('phonePrefix')}}: </b>
                            <span>{{item.phonePrefix}}</span>
                        </div>
                        <div class="col-lg-2">
                            <b class="c-smart-table__label">{{$t('currency')}}: </b>
                            <span>{{item.currency}}</span>
                        </div>
                        <div class="col-lg-2">
                            <div class="c-smart-table__content">
                                <div class="c-buttons clearfix is-2">
                                    <div class="c-buttons__col">
                                        <button @click="update(item._id)" type="button"
                                            class="btn btn-sm btn-info mr-1">
                                            <font-awesome-icon icon="edit" />&nbsp;{{$t('edit')}}
                                        </button>
                                        <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                                            <font-awesome-icon icon="trash" />&nbsp;{{$t('delete')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center text-danger" v-if="!items.length">
                <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{$t('notFoundCreate')}}</span>
                <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{$t('notFoundSearch')}}</span>
            </div>
            <div class="col-12" v-if="itemCount">
                <div class="c-paging__count" v-if="itemCount">
                    {{$t('found', [itemCount])}}
                </div>
                <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
                </b-pagination>
            </div>
        </div>
        <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
            <form-input :label="$t('localeCode')" :model="formModel" attribute="localeCode" :errors="formErrors">
            </form-input>
            <form-input :label="$t('languageCode')" :model="formModel" attribute="languageCode" :errors="formErrors">
            </form-input>
            <form-input :label="$t('phonePrefix')" :model="formModel" attribute="phonePrefix" :errors="formErrors">
            </form-input>
            <form-input :label="$t('currency')" :model="formModel" attribute="currency" :errors="formErrors">
            </form-input>
        </b-modal>
    </main>
</template>
<script>
    import List from '../mixins/List';
    import CRUD from "../mixins/CRUD";
    export default {
        mixins: [List, CRUD],
        data: function() {
            return {
                service: '/country',
                defaultFormModel: {},
                autoLoad: true
            }
        },
        i18n: {
            messages: {
                en: {
                    title: 'Countries list',
                    name: 'Country name',
                    localeCode: 'Locale code',
                    languageCode: 'Language code',
                    phonePrefix: 'Phone prefix',
                    currency: 'Currency'
                },
                vi: {
                    title: 'Danh sách quốc gia',
                    name: 'Tên nước',
                    localeCode: 'Mã nước',
                    languageCode: 'Mã ngôn ngữ',
                    phonePrefix: 'Mã điện thoại',
                    currency: 'Đơn vị tiền tệ'
                }
            }
        },
        methods: {}
    }
</script>